import React, { useMemo } from "react";
import TSUtils from "../../../../utils/helpers/TSUtils";
import CurrencyProp from "../model/CurrencyProp";

interface Props {
  emoji: string;
  amount: number;
  multiplier: number;
  text: string;
  computeFn: (
    amt: number,
    multiplier: number,
    currency: string,
    subUnits: number,
    ctaValue: number
  ) => string;
  hideIfZero: boolean;
  subText: string;
  isAmount?: boolean;
  currency: CurrencyProp;
  ctaValue: number;
}

export default function MonthlyStatsDetailRow(props: Props) {
  const text = useMemo(() => {
    if (props.isAmount) {
      return `${props.emoji} ${TSUtils.formatAmountRoundUp(props.amount, props.currency.trigram, props.currency.subUnits)} ${props.text}`;
    }
    return `${props.emoji} ${props.amount} ${props.text}`;
  }, [props]);

  if (props.hideIfZero && !props.amount) {
    return null;
  }

  return (
    <tr>
      <td>{text}</td>
      <td className="text-center">
        {props.computeFn(
          props.amount,
          props.multiplier,
          props.currency.trigram,
          props.currency.subUnits,
          props.ctaValue
        )}
      </td>
      <td>{props.subText}</td>
    </tr>
  );
}
